/** XeAgents.ai**/
/**
 * The ONE definition of the public demo booking event.
 *
 * Lives in shared/ because every surface needs it: the landing page embed, the
 * pilot modal, and the server's confirmation and nudge emails. Two copies is
 * how a page and an email silently book different calendars with nothing
 * failing anywhere.
 */

/** Cal.com's "user/slug" form, which the embed takes. */
export const CAL_LINK = "abhiseksinha/voicepro-ai-product-walkthrough";

/**
 * Base namespace for the embed.
 *
 * Cal refuses a SECOND inline embed under the same namespace - it logs
 * "Inline embed already exists" and renders a blank box. A landing-page
 * calendar plus a modal calendar is exactly that, and so is closing and
 * reopening the modal. Never pass this directly; call `calNamespace()` so every
 * mounted instance gets its own.
 */
const CAL_NAMESPACE_BASE = "voicepro-ai-product-walkthrough";

let namespaceCounter = 0;
/** A fresh namespace per embed instance. See CAL_NAMESPACE_BASE. */
export function calNamespace(): string {
  namespaceCounter += 1;
  return `${CAL_NAMESPACE_BASE}-${namespaceCounter}`;
}

/**
 * The same event as an absolute URL, for emails and "open the booking page"
 * links. overlayCalendar lets the visitor overlay their own calendar on the
 * slot picker, which is only useful on the full page - the embed gets it
 * through its own config.
 */
export const CAL_BOOKING_URL = `https://cal.com/${CAL_LINK}?overlayCalendar=true`;

/**
 * Duration and platform, together, because they are the same kind of thing: a
 * CLAIM about the booking tool's configuration rather than a reading of it.
 *
 * Both were verified against the live event page on 2026-09-16, which rendered
 * "30m" and "MS Teams". Swapping the Cal event is what exposes a stale value -
 * the previous event was 30m/Cal Video while the copy said 60 min, and the
 * contradiction was visible in the same modal. Re-check both here whenever the
 * event changes; nothing in the code can detect the drift for you.
 */
export const DEMO_EVENT = {
  durationMinutes: 30,
  platform: "MS Teams",
  /** "30-minute" - for "a 30-minute call on MS Teams". */
  get durationLabel() {
    return `${this.durationMinutes}-minute`;
  },
} as const;

/**
 * Credits granted with a pilot.
 *
 * The same constant is the onboarding default for an owner created from a pilot
 * request, so the number promised on the landing page and the number actually
 * granted cannot drift apart.
 */
export const PILOT_CREDITS = 100;
